import { AxiosPromise } from 'axios';
import { actionSet } from '~/api/client';

const Image = {
  set: (imageBase64: string): AxiosPromise<IImageResponse> =>
    actionSet('/admin/image', null, { '@type': 'SaveImagePayload', imageBase64 }),
};

export default Image;
